import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

export class ZIDXAccountSuperAdminWixSiteLogContainer implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSuperAdminWixSiteLogContainer";
    }
    render(){
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
    }
}

